import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Paper, Grid, Skeleton, Box } from "@mui/material";
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import PreviousAssessments from "./partials/home/PreviousAssessments";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import HealthShelfComponent from "./partials/home/HealthShelfComponent";
import DisplayMode from "./partials/displaymodes/DisplayMode";
import OutboundSamlLink from "./partials/home/OutboundSAMLLink";
import { fetchErrorMessages } from "../reducers/reference_errormessages";
import { surveyClear } from "../reducers/survey";
import HomeAssessmentLibrary from "./partials/dynamic/HomeAssessmentLibrary";
import HomeHealthTools from "./partials/dynamic/HomeHealthTools";
import HomeBanner from "./partials/dynamic/HomeBanner";
import HTMLBlock from "./partials/dynamic/HTMLBlock";
import { fetchViewInstances, selectViewInstanceById } from "../reducers/reuseable_vi";
import { selectGlobalSettingEntities, selectSettingForTypeKeyName } from "../reducers/reference_settings";
import { profileClear } from "../reducers/profile";


const Home = () => {

  const { user: currentUser } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [callVI, setCallVI] = useState(false)
  const viewInstance = useSelector(state => selectViewInstanceById(state, 'HomePage'))
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const settings = useSelector(state => selectGlobalSettingEntities(state))
  const errormessageStatus = useSelector(state => state.errormessages.status)
  const setting_medikeeper = useSelector(state => selectSettingForTypeKeyName(state, { SettingTypeKeyName: 'MEDIKEEPER ENABLED MENU' }))
  const setting_healthshelf = useSelector(state => selectSettingForTypeKeyName(state, { SettingTypeKeyName: 'SHOW HEALTH SHELF' }))

  useEffect(() => {
    if (window !== undefined) {
      window.scrollTo(0, 0)
      
    }
  }, [])

  const surveyStatus = useSelector(state => state.surveys.status)
  useEffect(() => {
    if (surveyStatus === 'success') {
      dispatch(surveyClear())
    }
  }, [surveyStatus])
  /*if (!currentUser) {
    return <Navigate to="/login" />;
  }*/

  useEffect(() => {

  }, [viewInstance])

  const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
      opacity: 1, x: 0, y: 0,
      transition: {
        delay: 0.1,
        duration: 0.5,
      }
    }
  }
  return (
    <div>

      {
        viewInstance?.status==='success' && viewInstance.HomePage && !loading ? (

          <main>
            <Grid container direction="row" spacing={2} role="region" aria-label="Home Page Content">
              <Grid item xs={12}>
                <Box sx={{ marginTop: { md: "150px", sm: "100px", xs: "60px" } }} role="spacing">

                </Box>
              </Grid>
              <Grid item xs={12}>
                <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                  <Paper elevation={1} style={{ padding: '40px' }}>
                    <DisplayMode HomePage={viewInstance.HomePage} settings={viewInstance.settings} />
                  </Paper>
                </motion.div>
              </Grid>
              <Grid item xs={12}>
                <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                  <Paper elevation={1} py={4} px={2}>
                    <PreviousAssessments PreviousAssessmentsFrame={viewInstance.HomePage.PreviousAssessmentsFrame} />
                  </Paper>
                </motion.div>
              </Grid>
              {setting_medikeeper === "1" &&
                viewInstance && viewInstance.HomePage && viewInstance.HomePage.HealthTools
                && viewInstance.HomePage.HealthTools.Visible === '1'
                &&
                <Grid item xs={12}>
                  <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                    <Paper elevation={1} style={{ padding: '40px' }}>
                      <OutboundSamlLink link={viewInstance.HomePage.MedikeeperURL} HealthToolsFrame={viewInstance.HomePage.HealthTools} />
                    </Paper>
                  </motion.div>
                </Grid>}
              {setting_healthshelf === "1" &&
                <Grid item xs={12}>
                  <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                    <Paper elevation={1} py={4} px={2}>
                      <HealthShelfComponent HealthShelfFrame={viewInstance.HomePage.HealthShelfFrame} />
                    </Paper>
                  </motion.div>
                </Grid>}
              {/* <Grid item xs={12}>
                <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                  <Paper elevation={1} py={4} px={2}>
                    <Button onClick={()=>{handleAdminClick()}}>Admin</Button>
                  </Paper>
                </motion.div>
              </Grid> */}

            </Grid>
           
          </main>

        ) : (
          <Box p={2} mt={2} alignItems="center" justifyContent="center" style={{ marginTop: '150px', padding: '40px' }}>
            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2} role="region" aria-label="Loading Content">
              {[1, 2, 3].map((x) => {
                return (

                  <Grid item xs={12} key={x}>
                    <Paper elevation={1} role="presentation">

                      <Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "30%" }} height={0} />
                    </Paper>
                  </Grid>
                )
              }
              )}

            </Grid>
          </Box>
        )
      }

    </div>
  );


};

export default Home;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */